// extracted by mini-css-extract-plugin
export default {"container":"feed-empty-list_container__xXfuO","emptyIcon":"feed-empty-list_emptyIcon__j5JHu"};